export function useDynamicIcons() {
  function loadIcon(icon: string) {
    if (!icon) {
      console.warn('Icon name is required')
      return 'div'
    }

    const iconName = useDash(icon)

    // TODO: extend with configurable mapping

    // Map specific icon names to their paths in the icon collection
    const iconMappings: Record<string, string> = {
      'arrow-left': 'icon:arrow',
      'arrow-right': 'icon:arrow',

      // Payment methods
      'afterpay': 'icon:payment-methods-afterpay',
      'american-express': 'icon:payment-methods-american-express',
      'apple-pay': 'icon:payment-methods-apple-pay',
      'bancontact': 'icon:payment-methods-bancontact',
      'cadeaubonnen': 'icon:delivery-methods-woonboulevard-poortvliet',
      'mistercash': 'icon:payment-methods-bancontact',
      'billink': 'icon:payment-methods-billink',
      'de-cadeaukaart': 'icon:payment-methods-de-cadeaukaart',
      'flying-blue': 'icon:payment-methods-flying-blue',
      'ideal': 'icon:payment-methods-ideal',
      'klarna': 'icon:payment-methods-klarna',
      'maestro': 'icon:payment-methods-maestro',
      'mastercard': 'icon:payment-methods-mastercard',
      'paypal': 'icon:payment-methods-paypal-icon',
      'paypal-icon': 'icon:payment-methods-paypal-icon',
      'pin': 'icon:payment-methods-pin',
      'visa': 'icon:payment-methods-visa',
      'visamastercard': 'icon:payment-methods-creditcard',

      'checkmo': 'icon:payment-methods-pin',

      // Delivery Icons
      'dpd': 'icon:delivery-methods-dpd',
      'dhl': 'icon:delivery-methods-dhl',
      'postnl': 'icon:delivery-methods-post-nl',
      'post-nl': 'icon:delivery-methods-post-nl',
      'ups': 'icon:delivery-methods-ups',

      'flatrate-flatrate': 'icon:delivery-methods-post-nl',
      'tablerate-bestway': 'icon:delivery-methods-woonboulevard-poortvliet',
      'woonboulevard-poortvliet': 'icon:delivery-methods-woonboulevard-poortvliet',

      // Social media
      'facebook': 'icon:social-media-facebook',
      'instagram': 'icon:social-media-instagram',
      'pinterest': 'icon:social-media-pinterest',
      'youtube': 'icon:social-media-youtube',
      'tiktok': 'icon:social-media-tiktok',

      // Labels
      'becommerce': 'icon:labels-becommerce',
      'cbw': 'icon:labels-cbw',
      'drug-provider': 'icon:labels-drug-provider',
      'eu-organic': 'icon:labels-eu-organic',
      'kiyoh': 'icon:labels-kiyoh',
      'thuiswinkel-waarborg': 'icon:labels-thuiswinkel-waarborg',

      // Custom
      'hofleverancier': 'icon:labels-hofleverancier',
    }

    // Check if we have a specific mapping for this icon
    if (iconMappings[iconName]) {
      return iconMappings[iconName]
    }

    if (!iconName || iconName === 'no-icon') {
      return ''
    }

    // For general icons, try the standard icon: prefix
    const generalIconName = `icon:${iconName}`

    return generalIconName
  }

  return {
    loadIcon,
  }
}
